export default () => {
    const {basic, extreme, strict, etpStudy} = window.__STATE__.cookieTracking;

    var basicPromiseDeferred;
    var basicPromise = new Promise(function(resolve, reject){
        basicPromiseDeferred = {resolve: resolve, reject: reject};
    });

    var extremePromiseDeferred;
    var extremePromise = new Promise(function(resolve, reject){
        extremePromiseDeferred = {resolve: resolve, reject: reject};
    });

    function isGALoaded() {
        return (typeof ga === 'function' && typeof ga.getAll === 'function' && ga.getAll().length > 0);
    }

    function checkIfGALoaded(resolve) {
        if (isGALoaded()) {
            resolve();
            return;
        }

        setTimeout(function() {
            checkIfGALoaded(resolve)
        }, 1000);
    }

    var googleAnalyticsPromise = new Promise(function(resolve, reject){
        checkIfGALoaded(resolve);
    });

    function receiveMessage(event) {
        if (event.origin === basic.domain) {
            basicPromise = basicPromiseDeferred.resolve(cookiesBlocked(event.data));
        } else if (event.origin === extreme.domain) {
            extremePromise = extremePromiseDeferred.resolve(cookiesBlocked(event.data));
        }
    }

    /**
     * Returns true if cookies are blocked
     * @param data
     * @returns {boolean}
     */
    function cookiesBlocked(data) {
        return data == 'no_cookies';
    }

    Promise.all([googleAnalyticsPromise, basicPromise, extremePromise]).then(function(values) {
        var eventLabel = 'unknown';
        if (values[1] && !values[2]) {
            eventLabel = 'basic';
        } else if(values[2]) {
            eventLabel = 'extreme';
        } else if(!values[1] && !values[2]) {
            eventLabel = 'none';
        }

        const trackerName = ga.getAll()[0].get('name');
        ga(`${trackerName}.send`, {
            hitType: 'event',
            eventCategory: 'TrackingProtection',
            eventAction: 'setting',
            eventLabel: eventLabel,
            nonInteraction: true
        });
    });

    googleAnalyticsPromise.then(values => {
      const trackerName = ga.getAll()[0].get('name');
      ga(`${trackerName}.send`, {
        hitType: 'event',
        eventCategory: 'FirefoxStudyTrackingProtection',
        eventAction: 'setting',
        eventLabel: etpStudy,
        nonInteraction: true
      });
    });

    window.addEventListener("message", receiveMessage, false);

    var basicFrame = document.createElement('iframe');
    basicFrame.setAttribute('id', 'basicFrame');
    basicFrame.setAttribute('style', 'display: none; width:0; height:0; border:0; border:none;');
    document.body.appendChild(basicFrame);
    basicFrame.setAttribute('src', basic.domain + basic.page);

    var extremeFrame = document.createElement('iframe');
    extremeFrame.setAttribute('id', 'extremeFrame');
    extremeFrame.setAttribute('style', 'display: none; width:0; height:0; border:0; border:none;');
    document.body.appendChild(extremeFrame);
    extremeFrame.setAttribute('src', extreme.domain + extreme.page);
};



